import { Container } from 'react-bootstrap';
import './assets/css/style.scss';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { Article } from '../../../../shared/interfaces';

function HomeArticles() {
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    fetch('https://strapi-production-a706.up.railway.app/api/articles?populate=*&sort=createdAt:desc')
      .then((res) => res.json())
      .then((data) => {
        setArticles(data.data || []);
      })
      .catch((err) => console.error('Failed to fetch articles:', err));
  }, []);

  const latestArticles = articles.slice(0, 4);

  return (
    <div className="section templates">
      <Container>
        <div className="section__title">
          <div className="section__label">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="15"
              viewBox="0 0 25 15"
              fill="none"
            >
              <g clipPath="url(#clip0_18_208)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M24.5 0.0145264L16.8419 14.9856H9.64869L12.8538 8.781H12.7098C10.0659 12.213 6.12083 14.4725 0.5 14.9856V8.86682C0.5 8.86682 4.09578 8.65434 6.20975 6.4319H0.5V0.0148545H6.91705V5.2927L7.061 5.29209L9.68328 0.0148545H14.5365V5.25937L14.6804 5.25909L17.4011 0.0145264H24.5Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_18_208">
                  <rect
                    width="24"
                    height="14.971"
                    fill="white"
                    transform="translate(0.5 0.0145264)"
                  />
                </clipPath>
              </defs>
            </svg>
            <div className="section__label-text">Dije të lashta</div>
          </div>
          <h2>Artikuj të ndryshëm</h2>
        </div>

        <div className="section__content">
          {latestArticles?.map((article) => (
            <div className="templates__item" key={article.id}>
              <div className="templates__item-icon">
                <img
                  src={article?.image?.url}
                  alt={article?.title}
                />
              </div>
              <div className="templates__item-title">
                  <Link to={`/article/details/${article?.id}`}>
                    {article?.title}
                  </Link>
                <p>
                  {article?.description?.length > 300
                    ? article?.description?.substring(0, 300) + '...'
                    : article?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div
          className="templates__more-button-wrapper"
          style={{ textAlign: 'center', marginTop: '30px' }}
        >
          <Link to="/artikuj" className="button button--secondary">
            <span>Më shumë artikuj</span>
          </Link>
        </div>
      </Container>
    </div>
  );
}

export default HomeArticles;
